/* unplugin-vue-components disabled */import { render } from "./mission.vue?vue&type=template&id=afcc0942&scoped=true&ts=true"
import script from "./mission.vue?vue&type=script&lang=ts"
export * from "./mission.vue?vue&type=script&lang=ts"

import "./mission.vue?vue&type=style&index=0&id=afcc0942&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcc0942"]])

export default __exports__